import { jsx } from "panel";
import { ButtonEl } from "common/components/button";
import { ButtonSize, ButtonTheme } from "common/components/button/constants";
import { RadioButtonEl } from "common/components/radio-button";
import { SvgIconEl } from "common/components/svg-icon";
import { StripeCCFormEl } from "common/widgets/stripe-cc-form";
import { PricingCurveVariant } from "media/js/pricing/api/types";
import { TrackingEvents } from "media/js/pricing/tracking";
import toggleStyleOverride from "./mp2023-toggle.inline.styl";
export function template() {
  var _a, _b, _c, _d, _e, _f;
  const showNotChargedToday = ((_a = this.app.state) == null ? void 0 : _a.amountDueInfo) && ((_c = (_b = this.app.state) == null ? void 0 : _b.amountDueInfo) == null ? void 0 : _c.amount) === 0;
  const allowPaymentViaCreditCard = !!((_d = this.app.state) == null ? void 0 : _d.allowPaymentViaCreditCard) && this.app.state.customerInfo.orgInfo.canPurchaseOnline;
  const allowPaymentViaInvoice = this.app.helpers.getSelectedPlanState().curveVariant === PricingCurveVariant.ENTERPRISE || !this.app.state.customerInfo.orgInfo.canPurchaseOnline;
  const { billingCard } = this.app.state;
  const paymentOptionToggle = () => {
    const options = [
      { label: `Pay with Card`, value: this.helpers.PaymentMethod.CREDIT_CARD },
      { label: `Pay with Invoice`, value: this.helpers.PaymentMethod.INVOICE }
    ];
    return /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".toggle-wrapper"
    }, options.map((option) => {
      const isSelected = option.value === this.state.selectedPaymentMethod;
      return /* @__PURE__ */ jsx(ButtonEl, {
        sel: ".toggle-button",
        class: { selected: isSelected },
        attrs: {
          theme: ButtonTheme.Tertiary,
          selected: isSelected,
          "style-override": toggleStyleOverride
        },
        on: { click: () => this.helpers.updateSelectedPaymentMethod(option.value) }
      }, option.label);
    })));
  };
  const contactSupportBtn = () => {
    return /* @__PURE__ */ jsx("a", {
      sel: ".support-btn",
      attrs: {
        role: `button`,
        tabindex: 0,
        href: `/get-support`,
        target: `_blank`
      },
      on: { click: () => this.app.helpers.trackEventWithPlanProps(TrackingEvents.ContactSupport) }
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `brand-help` }
    }), "Contact support");
  };
  const showCreditCardPaymentForm = () => {
    return this.state.selectedPaymentMethod === this.helpers.PaymentMethod.CREDIT_CARD && (billingCard && !this.state.editingCardInfo ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
      sel: ".step-description"
    }, /* @__PURE__ */ jsx("div", {
      sel: ".card-on-file-text"
    }, "We have a credit card on file for your account."), /* @__PURE__ */ jsx("div", {
      sel: ".existing-billing-description"
    }, /* @__PURE__ */ jsx("div", null, `${billingCard.type} \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 \xB7\xB7\xB7\xB7 ${billingCard.last4}`), /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `edit` },
      sel: ".edit-icon",
      on: { click: this.helpers.toggleEditingCardInfo }
    })), /* @__PURE__ */ jsx("div", {
      sel: ".exp-date"
    }, "Expires ", `${billingCard.expiryMonth}/${billingCard.expiryYear}`)), this.attr(`mp-2023-style`) && showNotChargedToday && /* @__PURE__ */ jsx("div", {
      sel: ".info-icon-area"
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `info` },
      sel: ".info-icon"
    }), /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file.")), /* @__PURE__ */ jsx("div", {
      sel: ".review-btn-area.btn-rows"
    }, /* @__PURE__ */ jsx(ButtonEl, {
      attrs: {
        theme: this.attr(`mp-2023-style`) ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
        role: `button`,
        tabindex: 0,
        size: ButtonSize.Large,
        disabled: this.state.reviewBtnLoading
      },
      on: { click: this.helpers.handleReviewBtnClick }
    }, `${this.state.reviewBtnLoading ? `Processing` : `Review`}`), this.attr(`mp-2023-style`) && contactSupportBtn(), !this.attr(`mp-2023-style`) && showNotChargedToday && /* @__PURE__ */ jsx("div", {
      sel: ".info-icon-area"
    }, /* @__PURE__ */ jsx(SvgIconEl, {
      attrs: { icon: `info` },
      sel: ".info-icon"
    }), /* @__PURE__ */ jsx("span", null, "Your card will not be charged today, but we do require a card on file.")))) : /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(StripeCCFormEl, {
      attrs: {
        "is-modal": false,
        "account-id": this.app.state.customerInfo.orgInfo.accountId,
        "editing-card-info": this.state.editingCardInfo,
        "review-btn-loading": this.state.reviewBtnLoading,
        "show-not-charged-today": showNotChargedToday,
        "mp-2023-style": this.attr(`mp-2023-style`)
      },
      on: {
        "submit-pb2": this.helpers.handleReviewBtnClick,
        "toggle-edit-card": this.helpers.toggleEditingCardInfo,
        "change-selected-payment-info": (ev) => this.app.helpers.handleChangeSelectedPaymentInfo(ev.detail)
      }
    }), this.attr(`mp-2023-style`) && /* @__PURE__ */ jsx("div", {
      sel: ".stripe-support-btn"
    }, contactSupportBtn())));
  };
  const showInvoicePaymentForm = () => {
    return this.state.selectedPaymentMethod === this.helpers.PaymentMethod.INVOICE && /* @__PURE__ */ jsx("div", {
      sel: ".positioning-box"
    }, (!this.attr(`mp-2023-style`) || this.state.allowedPaymentMethod === this.helpers.PaymentMethod.BOTH) && /* @__PURE__ */ jsx("div", {
      sel: ".step-description"
    }, "Submit a request to pay with an invoice. Our sales team will receive the details of your selected plan and assist you in getting started."), /* @__PURE__ */ jsx("div", {
      sel: ".btn-rows"
    }, /* @__PURE__ */ jsx("a", {
      attrs: { href: this.helpers.createInvoicePaymentLinkUrl() }
    }, /* @__PURE__ */ jsx(ButtonEl, {
      attrs: {
        theme: this.attr(`mp-2023-style`) ? ButtonTheme.MarketingPrimary : ButtonTheme.Primary,
        role: `button`,
        tabindex: 0,
        size: ButtonSize.Large
      },
      on: { click: () => this.app.helpers.trackEventWithPlanProps(`Click Continue to Invoice Payment`) }
    }, "Continue")), this.attr(`mp-2023-style`) && contactSupportBtn()));
  };
  return /* @__PURE__ */ jsx("div", {
    sel: "#payment-info"
  }, this.attr(`mp-2023-style`) ? /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx("div", {
    sel: ".step-title"
  }, (_e = this.helpers.PaymentTitleDescription[this.state.allowedPaymentMethod]) == null ? void 0 : _e.title), /* @__PURE__ */ jsx("div", {
    sel: ".step-description"
  }, (_f = this.helpers.PaymentTitleDescription[this.state.allowedPaymentMethod]) == null ? void 0 : _f.description), this.state.allowedPaymentMethod === this.helpers.PaymentMethod.BOTH && paymentOptionToggle(), this.state.billingDataFetched && showCreditCardPaymentForm(), showInvoicePaymentForm()) : /* @__PURE__ */ jsx("div", {
    sel: ".step-title"
  }, "Payment Info"), !this.attr(`mp-2023-style`) && allowPaymentViaCreditCard && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(RadioButtonEl, {
    className: "radio-button",
    focused: this.state.focusedPaymentMethod === this.helpers.PaymentMethod.CREDIT_CARD,
    selected: this.state.selectedPaymentMethod === this.helpers.PaymentMethod.CREDIT_CARD,
    tabIndex: 0,
    onBlur: () => this.helpers.updateFocusedPaymentMethod(this.helpers.PaymentMethod.NO_METHOD),
    onClick: () => this.helpers.updateSelectedPaymentMethod(this.helpers.PaymentMethod.CREDIT_CARD),
    onFocus: () => this.helpers.updateFocusedPaymentMethod(this.helpers.PaymentMethod.CREDIT_CARD),
    onKeyDown: (ev) => this.helpers.updateSelectedPaymentMethodOnKeystroke(ev, this.helpers.PaymentMethod.CREDIT_CARD),
    children: "Pay with card"
  }), showCreditCardPaymentForm()), !this.attr(`mp-2023-style`) && allowPaymentViaInvoice && /* @__PURE__ */ jsx(null, null, /* @__PURE__ */ jsx(RadioButtonEl, {
    className: "radio-button",
    focused: this.state.focusedPaymentMethod === this.helpers.PaymentMethod.INVOICE,
    selected: this.state.selectedPaymentMethod === this.helpers.PaymentMethod.INVOICE,
    tabIndex: 0,
    onBlur: () => this.helpers.updateFocusedPaymentMethod(this.helpers.PaymentMethod.NO_METHOD),
    onClick: () => this.helpers.updateSelectedPaymentMethod(this.helpers.PaymentMethod.INVOICE),
    onFocus: () => this.helpers.updateFocusedPaymentMethod(this.helpers.PaymentMethod.INVOICE),
    onKeyDown: (ev) => this.helpers.updateSelectedPaymentMethodOnKeystroke(ev, this.helpers.PaymentMethod.INVOICE),
    children: "Pay with invoice"
  }), showInvoicePaymentForm()));
}
